import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { levittownConfig } from "./data";

export default function LevittownPage() {
  return <CityPageTemplate config={levittownConfig} />;
}